import React from 'react';
import { Grid, MenuItem } from '@mui/material';
import { Field, Form, withFormik } from 'formik';
import * as Yup from 'yup';

import useNewTicketForm, { NewTicketSchema } from './use-new-ticket';
import ChatInput from 'features/tickets/chat/components/chat-input/chat-input';

const FormTemplate = (props: any): JSX.Element => {
    const {
        newTicketFields,
        ticketError,
        isSending,
        sentMessage,
        fileSizeLimit,
        onSend,
        onResend,
        onCancel,
        onErrorFile,
    } = useNewTicketForm(props);

    return (
        <>
            <Form>
                <Grid container spacing={2} sx={{ py: 1 }}>
                    {newTicketFields?.map((field) => {
                        return (
                            <Grid
                                item
                                xs={12}
                                sm={field.name === 'title' || field.name === 'gateway_id' ? 12 : 6}
                                key={field.name}>
                                <Field
                                    component={field.component}
                                    select={field?.options ? true : false}
                                    liveValidation={false}
                                    {...field}>
                                    {field.options?.map((menu: any) => (
                                        <MenuItem
                                            value={menu.value}
                                            key={menu.value}>
                                            {menu.label}
                                        </MenuItem>
                                    ))}
                                </Field>
                            </Grid>
                        );
                    })}
                </Grid>
            </Form>


            <ChatInput
                isSending={isSending}
                isNewTicket={true}
                sentMessage={sentMessage}
                fileUploadUrl={
                    import.meta.env.VITE_APP_API_URL + 'tickets/attachments'
                }
                fileSizeLimit={fileSizeLimit}
                inputProps={{
                    placeHolderText:
                        'لطفا شرح کاملی از تیکت خود را ارسال کنید',
                    fileHolderText:
                        'برای تیکت خود یک یا چند فایل بارگذاری کنید',
                    validLength: [3, 500],
                    error: ticketError,
                    smallScreen: true,
                    shadow: false,
                    borderRadius: '8px',
                }}
                onSend={onSend}
                onResend={onResend}
                onCancel={onCancel}
                onErrorFile={onErrorFile}
            />
        </>
    );
};

export const NewTicketForm: any = withFormik({
    mapPropsToValues: () =>
        ({
            title: '',
            gateway_id: '',
            department: '',
            priority: '',
        }) as any,
    validationSchema: Yup.object().concat(NewTicketSchema),
    validateOnChange: false,
    validateOnBlur: false,
    handleSubmit: (_values, { setSubmitting }) => {
        setSubmitting(false);
    },
})(FormTemplate);

export default NewTicketForm;
